export var clientMCAccessMapper = function (data) {
    var result = {};
    if (data) {
        result.strMsg = data.strMsg;
        result.strContactLnk = data.strContactLnk === "true" ? true : false;
    }
    return result;
};
